interface NameGeneratorResponse {
  text: string;
}

export const getGeneratedResults = async (description: string, mode: string, subject: string): Promise<string[]> => {
  const subjectToUse = subject || 'network_name_generator';
  const response = await fetch(getApiUrl(description, mode, subjectToUse), { method: 'GET' });
  const data: NameGeneratorResponse[] = await response.json();

  return data.map((item) => item.text);
};

const getApiUrl = (description: string, mode: string, subject: string): string =>
  `https://api.mn.co/integrations/marketing/v1/generators.json?mode=${mode}&subject=${subject}&description=${encodeURIComponent(
    description
  )}`;
